import React, { useContext, useEffect, useState, useRef } from "react";
import { ExternalLink } from "react-external-link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import moment from "moment";

const Anuncio = ({ anuncio }) => {
  //const { handleAgregarCarrito, handleComprar } = useContext(CarritoContext);
  //const { handleAgregarFavorito, handleEliminarFavorito } =
  //useContext(FavoritoContext);

  //const [portada, setPortada] = useState(false);
  //const favorito = useRef(null);
  //const [botones, setBotones] = useState(false);

  /*
  fetch('http://example.com/movies.json')
  .then(response => response.json())
  .then(data => console.log(data));
   */
  useEffect(() => {
    /*fetch(pelicula.portada).then((data) => {
      if (data.ok) setPortada(true);
    });*/
    //setBotones(pelicula.carrito.length > 0 ? true : false);
  }, []);

  /*const setFavorito = (pelicula) => {
    favorito.current.className =
      favorito.current.className ===
      "material-icons MuiIcon-root MuiIcon-colorSecondary"
        ? "material-icons MuiIcon-root MuiIcon-colorDisabled"
        : "material-icons MuiIcon-root MuiIcon-colorSecondary";

    favorito.current.className ===
    "material-icons MuiIcon-root MuiIcon-colorDisabled"
      ? handleEliminarFavorito(pelicula)
      : handleAgregarFavorito(pelicula);
  };*/

  return (
    <>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alignItems="top" alt="" src={anuncio.imagen} />
        </ListItemAvatar>
        <ListItemText
          primary={
            moment(anuncio.fecha).format("DD/MM/YYYY HH:MM") +
            " - " +
            anuncio.titulo
          }
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline" }}
                component="span"
                variant="body1"
                color="text.primary"
              >
                Administrador -
              </Typography>

              <Typography style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                {anuncio.descripcion}
              </Typography>
              <br />
              {anuncio.href && (
                <ExternalLink href={anuncio.href} target="_blank">
                  Clic aquí
                </ExternalLink>
              )}
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
};

export default Anuncio;
